import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Observable, Subject, Subscription} from 'rxjs';
import {Alert, AlertType} from './alert';

@Injectable()
export class AlertService {
    public subject = new Subject<Alert>();
    private keepAfterRouteChange = false;
     private subs = new Subscription();

    constructor(private router: Router) {
        this.subs.add(
            router.events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    if (this.keepAfterRouteChange) {
                        this.keepAfterRouteChange = false;
                    } else {
                        this.clear();
                    }
                }
            })
        );
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType.Success, message, keepAfterRouteChange);
    }

    // error(message: string, keepAfterRouteChange = false) {
    //     this.alert(AlertType.Errors, message, keepAfterRouteChange);
    // }

    info(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType.Info, message, keepAfterRouteChange);
    }

    warn(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType.Warning, message, keepAfterRouteChange);
    }

    alert(type: AlertType, message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<Alert>{type: type, message: message});
    }

    clear() {
        this.subject.next();
    }
}
